<script setup lang="ts">
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import AppImage from '@/components/shared/AppImage.vue';

const route = useRoute();

const links = [
  { href: '/', label: 'HOME' },
  { href: '/menu', label: 'MENU' },
  { href: '/locations', label: 'LOCATIONS' },
  { href: '/our-story', label: 'OUR STORY' },
  { href: '/catering', label: 'CATERING' },
  { href: '/parties', label: 'PARTIES' },
  { href: '/employment', label: 'EMPLOYMENT' },
];
const facebook = 'https://www.facebook.com/pages/Albanos-villa/429885887062790?ref=tn_tnmn';

/**
 * Highlight the link matching the current route, mirroring the original `Astro.url.pathname` check.
 */
function highlight(link: string): string {
  return route.path === link ? 'text-brand-red!' : '';
}

// Close the open mobile menu after navigating (the SPA router keeps the <details> open otherwise).
watch(
  () => route.fullPath,
  () => {
    for (const d of document.querySelectorAll<HTMLDetailsElement>('nav details[open]'))
      d.open = false;
  },
);
</script>

<template>
  <nav aria-label="Main navigation" class="lg:w-180 lg:shrink-0">
    <!-- Desktop nav -->
    <div class="text-20 hidden flex-col items-end lg:flex">
      <RouterLink
        v-for="link in links"
        :key="link.href"
        :to="link.href"
        :class="highlight(link.href)"
      >
        {{ link.label }}
      </RouterLink>
      <a :href="facebook" class="mt-20" target="_blank" rel="noopener">
        <AppImage
          name="find-us-on-facebook"
          alt="Find us on Facebook (opens in new tab)"
          sizes="100px"
        />
      </a>
    </div>
    <!-- Mobile nav -->
    <details class="text-16 group/nav flex flex-col items-end gap-15 lg:hidden">
      <summary aria-label="Toggle navigation menu">
        <span />
        <span />
        <span />
      </summary>
      <div class="flex flex-col items-end gap-5 font-bold">
        <RouterLink
          v-for="link in links"
          :key="link.href"
          :to="link.href"
          :class="highlight(link.href)"
        >
          {{ link.label }}
        </RouterLink>
        <a :href="facebook" class="mt-8" target="_blank" rel="noopener">
          <AppImage
            name="find-us-on-facebook"
            alt="Find us on Facebook (opens in new tab)"
            sizes="100px"
          />
        </a>
      </div>
    </details>
  </nav>
</template>
